import React from 'react'
import Head from 'next/head'
import { CorporateEventsWrapper as Wrapper } from '../components/corporate-events/styles'
import Hero from '../components/Hero'
import FAQ from '../faq'
import HowItWorks from '../components/how-it-works'
import WhyChecklist from '../components/why-checklist'
import ReviewScroll from '../components/review-scroll'
import BookEvent from '../components/book-event'

const FAQ_URL = '/faq/category/services'

const FAQ_DATA = [
  {
    id: 1,
    title: 'What Group Glam services do you provide?',
    body: `We offer all services on our standard menu for groups of two to four. Our concierge team will let you know how many pros you need (and for how long) based on your group size and requested services.`,
  },
  {
    id: 2,
    title: 'How many pros will I need for my group?',
    body: `You can book multiple pros to service all members of your party at once, or you can book one pro per service category (hair, makeup, nails) to service your group one at a time. Our concierge team will make a recommendation based on the size of your party, requested services, and your desired timing.`,
  },
  {
    id: 3,
    title: 'Can I use a promo code when booking a group glam?',
    body: `Glamsquad does not offer discounts on group glam services. Any credit codes in your account will apply to the appointments but our standard service packages will not apply.`,
  },
]

const GroupGlam = () => {
  const handleClick = () => {
    if (typeof window !== 'undefined') {
      window.location.href = '/events/contact?origin=group-glam'
    }
  }

  const howItWorks = {
    "Give us the deets": "Choose services from our standard menu, then let us know where, when, and how many guests.",
    "Get booked": "Our concierge team will match you with the right beauty pros and get you on the schedule.",
    "Enjoy glam with friends": "Our pros show up with everything they need, so you can sit back and get glam with your crew."
  }

  const highlights = [
    "Customizable service combinations",
    "Available in 14 cities",
    "Talented, trusted, background-checked beauty pros",
    "Great for bachelorettes, spa parties, birthdays, pre-games & beyond"
  ]

  const reviews = [
    {
      quote: '"Anette gelled extremely well with my friend group. I loved how receptive she was and even gave ideas to execute what the girls wanted for makeup."',
      name: "Jaiwuan B."
    },
    {
      quote: '"Our blowouts by Edo were perfect! He was on time, friendly, and an artist at working with each of our blowouts."',
      name: "Kim K."
    },
    {
      quote: '"The perfect complement to our black tie event. They met us at the hotel and had us ready in record time. Everyone was professional & talented."',
      name: "Michele D."
    }
  ]

  return (
    <>
      <Head>
        <title>Group Glam | GLAMSQUAD</title>
        <meta name="description" content="In-home hair, makeup, and nails for groups of 2-4. Bachelorettes, birthdays, and girls' nights in 14 cities. Book in minutes." />
        <link rel="canonical" href="https://glamsquad.com/group-glam" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Group Glam | GLAMSQUAD" />
        <meta property="og:description" content="In-home hair, makeup, and nails for groups of 2-4. Bachelorettes, birthdays, and girls' nights in 14 cities. Book in minutes." />
        <meta property="og:url" content="https://glamsquad.com/group-glam" />
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: FAQ_DATA.map((q) => ({
              '@type': 'Question',
              name: q.title,
              acceptedAnswer: { '@type': 'Answer', text: q.body },
            })),
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Service',
            name: 'Group Glam',
            serviceType: 'In-home group hair, makeup, and nail services',
            description:
              "In-home hair, makeup, and nail services for groups of two to four—bachelorettes, birthdays, and girls' nights.",
            provider: { '@id': 'https://glamsquad.com/#organization' },
            url: 'https://glamsquad.com/group-glam',
          })}
        </script>
      </Head>
      <Wrapper>
        <Hero
          className="hero-component"
          header='Group Glam'
          subheader='Friends don&apos;t let friends get glam alone. Our at-home group hair and makeup services bring your favorite Glamsquad beauty services to groups of two to four.'
          image={require('../../public/group-glam-friends-makeup-champagne.jpeg')}
          imageAlt='Friends with fresh hair and makeup posing with champagne at an at-home group glam session'
          hideCTA={false}
          buttonTitle='Book Now'
          ctaClick={handleClick}
        />
        <HowItWorks data={howItWorks} />
        <WhyChecklist
          {...{ handleClick }}
          buttonTitle='Book Group Glam'
          headerTitle='Why you&apos;ll love it'
          image={require('../../public/group-glam-at-home-hair-makeup-nails.jpeg')}
          imageAlt='Woman getting her hair styled and nails done by GLAMSQUAD pros during an at-home group glam session'
          reasons={highlights}
        />
        <ReviewScroll reviews={reviews} />
        <FAQ data={FAQ_DATA} url={FAQ_URL} />
        <BookEvent
          title='Ready to book group glam?'
          {...{ handleClick }}
        />
      </Wrapper>
    </>
  )
}

export default GroupGlam
